/**
 * @NOTE
 * @InitialValues  - are equivalent to Types When in Used in Type Script
 */

export const createAccountInitialValues = {
  usertype: "",
  firstname: "",
  lastname: "",
  gender: "",
  email: "",
  phonenumber: "",
  password: "",
  confirmPassword: "",
  establishment: "",
  userlevel: "",
};

export const genderValues = [
  { value: "Male" },
  { value: "Female" },
  { value: "Others" },
];
